import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import * as _ from 'lodash';
import './mailingAddress.css';
import { submitPrivacyRequest } from "../../redux/MailingAddressSelector/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import BannerNotification from '../../banner/bannerNotification';
import BottomLine from '../Footer/BottomLine';
import './deletePreConfirm.css';

class DeleteInfoPreConfirmation extends Component {

  constructor(props) {
    super(props);
    if (!props?.selectedRequest) {
      window.location.replace("/");
    }
    this.state = {
      isLoading: false
    };
  }

  routeOnSubmit = () => {
    this.props.history.push("/formComplete", { isDeleteFormComplete: true });
  }

  render() {
    const handleSubmit = async () => {
      await this.props.submitPrivacyRequest(this.props.location.state.deleteRequestPayload, this.routeOnSubmit, this.props);
      this.setState({
        isLoading: true
      })
    }
    return (

      !this.state.isLoading &&
        <div className='delete-confirm'>
          {!_.isEmpty(this.props.networkError) && (
            <BannerNotification notificationStyle='error'>
              {this.props.networkError.error && i18n.t(rk.ERROR_API_FAIL)}
            </BannerNotification>
          )}
          <div className="o-layout">
            <div className="o-layout__item u-1/1">
              <div className="title">
                <span>{i18n.t(rk.DELETE_REQUEST_CONFIRMATION)}</span>
              </div>
            </div>
          </div>
          <div className="delete-button-wrapper">
            <div className="exit-btn-wrapper">
              <button
                className="c-btn exit-btn"
                onClick={() => {
                  this.props.history.push('/');
                }}
                data-testid="exit-btn"
                id="exit-btn"
              >
                <span className="c-btn__text">
                  {i18n.t(rk.BUTTON.NO)}
                </span>
              </button>
            </div>
            <div className="cont-btn-wrapper">
              <button
                className="c-btn"
                onClick={handleSubmit}
                data-testid="continue-btn"
                id="continue-btn"
              >
                <span className="c-btn__text">
                  {i18n.t(rk.BUTTON.YES)}
                </span>
              </button>
            </div>
          </div>
          <div className='request-footer-wrapper'>
            <div
              id="request-footer-content"
              className="request-footer-content-2"
            >
              <BottomLine />
            </div>
          </div>
        </div>
    )
  }
}

DeleteInfoPreConfirmation.propTypes = {
  selectedRequest: PropTypes.object,
  submitPrivacyRequest: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      deleteRequestPayload: PropTypes.object
    })
  }).isRequired,
  networkError: PropTypes.object,
};

const mapStateToProps = state => ({
  info: state.info,
  mailingAddress: state.mailingAddress,
  suggestedMailingAddress: state.suggestedMailingAddress,
  stateSelector: state.stateSelector,
  requestSelector: state.requestSelector,
  selectedRequest: state.requestSelector.selectedRequest,
  networkError: state.networkError,
});

const mapDispatchToProps = dispatch => ({
  submitPrivacyRequest: (action, routeProps, historyProps) => dispatch(submitPrivacyRequest(action, routeProps, historyProps)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(DeleteInfoPreConfirmation));

